import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

export const PlantReducer = createSlice({
    name: "plant",
    initialState,
    reducers: {
        setPlant: (state, action) => {
            state.length = 0;
            action.payload.map(obj => {
                state.push(obj);
            });
        },
        updatePlant: (state, action) => {
            let objIndex = state.findIndex(stateObj => {
                return (stateObj._id === action.payload._id) ;
            });

            if (objIndex >= 0) {
                state.splice(objIndex, 1, action.payload);
            } else if(objIndex === -1) {
                state.push(action.payload);
            }
        },
        searchPlant: (state, action) => {
            let objIndex = state.filter(stateObj => {
                return (stateObj._id === action.payload) ;
            });

            return objIndex;
        }
    }
});
export const {setPlant, updatePlant, searchPlant} = PlantReducer.actions;

export default PlantReducer.reducer;